// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"LX-z"};